import { createStore } from 'vuex'

export default createStore({
  state: {
    value1:"",
    value2:{
      name:"test"
    },
    firstLoad:1,
    vanEnd:0,
  },
  mutations: {
    commitValue1(state,value){
      console.log("------------commitValue1:",value)
      state.value1=value
    },
    commitValue2(state,value){
      console.log("------------commitValue1:",value.name)
      state.value2.name=value.name
    },
    updateFirstLoad(state, newValue) {
      state.firstLoad = newValue;
    },
    updateVanEnd(state, newValue) {
      state.vanEnd = newValue;
    }
  },
  actions: {
  },
  modules: {
  }
})
